const BankAccountSetting = () => {
	return (
		<div>
			<div>銀行口座</div>
		</div>
	)
}

export default BankAccountSetting
